import { render, staticRenderFns } from "./Caiadmin.vue?vue&type=template&id=3be09acc&scoped=true"
import script from "./Caiadmin.vue?vue&type=script&lang=js"
export * from "./Caiadmin.vue?vue&type=script&lang=js"
import style0 from "./Caiadmin.vue?vue&type=style&index=0&id=3be09acc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3be09acc",
  null
  
)

export default component.exports